import IAmDeveloper from './IAmDeveloper'

export default IAmDeveloper